module.exports = __webpack_public_path__ + "img/category__5.5ffe8af7.svg";